<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="small">
      <el-row>
        <el-form-item
          :label="$l('form_label_ftyNoticeOutDocType') || '文档类型'"
          prop="ftyNoticeOutDocType"
        >
          <dict-select
            v-model="formData.ftyNoticeOutDocType"
            url="/master/common/dict/biz"
            :body="ftyNoticeOutDocTypeParams"
            :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            :selectedLabel.sync="formData.ftyNoticeOutDocTypeText"
            size="mini"
            clearable
            filterable
          ></dict-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item :label="$l('form_label_fileRemark') || '备注说明'">
          <el-input
            v-model="formData.remark"
            :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            :maxlength="500"
            show-word-limit
            clearable
            type="textarea"
          >
          </el-input>
        </el-form-item>
      </el-row>
    </el-form>
    <el-upload
      drag
      action="#"
      multiple
      :file-list="listFile"
      :auto-upload="false"
      :on-change="onFileChange"
      :on-remove="onFileChange"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        {{ $l('INDEX.file_upload_tips_first') || '将文件拖到此处，或'
        }}<em>{{ $l('INDEX.file_upload_tips_last') || '点击上传' }}</em>
      </div>
    </el-upload>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  data() {
    return {
      listFile: [],
      formData: {
        ftyNoticeOutDocType: '',
        ftyNoticeOutDocTypeText: '',
        remark: '',
      },
      ftyNoticeOutDocTypeParams: { dictType: 'ftyNoticeOutDocType' },
      rules: {
        ftyNoticeOutDocType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    ...mapActions('admin/upload', ['push']),
    onFileChange(files, fileList) {
      this.listFile = fileList
    },
    async validate() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return false
      if (!this.listFile || !this.listFile.length) {
        this.$message({
          message: '请选择出库单关联文档',
          type: 'warning',
        })
        return false
      }
      return true
    },
    async upload() {
      if (!(await this.validate())) return
      const {
        ftyNoticeOutDocType,
        ftyNoticeOutDocTypeText,
        remark,
      } = this.formData

      const files = this.listFile.map(({ name: fileName, raw }) => ({
        ftyNoticeOutDocType,
        ftyNoticeOutDocTypeText,
        fileName,
        raw,
        remark,
      }))

      const uploadTask = files.map((file) => {
        return new Promise((resolve) => {
          this.push({
            file: file.raw,
            added: ({ md5, suffix }) => {
              const fileCode = [md5, suffix].filter(Boolean).join('.')
              resolve({
                fileCode,
                fileName: file.fileName,
                ftyNoticeOutDocType: file.ftyNoticeOutDocType,
                ftyNoticeOutDocTypeText: file.ftyNoticeOutDocTypeText,
                remark: file.remark,
              })
            },
            fail: () => resolve(null),
          })
        })
      })
      return await Promise.all(uploadTask)
    },
  },
}
</script>
